export class Parameter {
  id: bigint;
  setup_prog: string;
  setup_user: string;
  setup_key: string;
  setup_type: string;
  setup_value: string;
  setup_unit: string;
  setup_group: number;
  setup_permission: string;
  setup_value2: number;
  setup_value3: number;
  setup_value4: number;
  setup_value5: number;
  setup_value6: string;
  actived: boolean;
}
